<template>
  <Teleport to="body">
    <Transition name="modal">
      <div class="kakao-invite-overlay" v-if="visible" @click.self="close">
        <div class="kakao-invite-popup">
          
          <div class="popup-badge">{{ badge }}</div>
          
          <div class="popup-content">
            <h3 class="title">{{ title }}</h3>
            <p class="message" v-html="message"></p>
          </div>

          <div class="popup-buttons">
            <button class="confirm" @click="handleFollow">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256"><path fill="#3C1E1E" d="M128 24C70.6 24 24 61.2 24 106.8c0 29.4 19.4 55.4 49.2 70.6l-9.6 35.4c-.8 3 2.6 5.4 5.2 3.6l42.2-28.2c5.4.8 11 1.2 16.8 1.2c57.4 0 104-37.2 104-82.8S185.4 24 128 24"/></svg>
              채널 추가하기
            </button>
            <button class="cancel" @click="close">괜찮아요</button>
          </div>

        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { ref } from 'vue'

const CHANNEL_PUBLIC_ID = '_DUlyn'

export default {
  props: {
    badge: { type: String, default: '🎉' },
    title: { type: String, default: '카카오톡 채널 추가' },
    message: { type: String, default: '채널을 추가하면<br/><strong>이벤트, 혜택 소식</strong>을 받을 수 있어요!' },
  },
  setup(props, { emit }) {
    const visible = ref(false)

    function show() {
      // 이미 추가한 사람은 안 보여줌
      if (localStorage.getItem('kakao_channel_customer') === 'true') return
      visible.value = true
    }

    function close() {
      visible.value = false
      emit('dismiss')
    }

    function handleFollow() {
      if (!window.Kakao?.Channel) {
        // SDK 없으면 카카오톡 채널 URL로 이동
        window.open(`https://pf.kakao.com/${CHANNEL_PUBLIC_ID}`, '_blank')
        localStorage.setItem('kakao_channel_customer', 'true')
        visible.value = false
        emit('followed')
        return
      }

      window.Kakao.Channel.followChannel({ channelPublicId: CHANNEL_PUBLIC_ID })
        .then(() => {
          localStorage.setItem('kakao_channel_customer', 'true')
          visible.value = false
          emit('followed')
        })
        .catch((err) => {
          console.error('채널 추가 에러', err)
          visible.value = false
        })
    }

    return { visible, show, close, handleFollow }
  }
}
</script>

<style scoped>
.kakao-invite-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.kakao-invite-popup {
  background: #fff;
  border-radius: 24px;
  padding: 32px 24px 24px;
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.popup-badge {
  font-size: 48px;
  line-height: 1;
}

.popup-content {
  text-align: center;
}

.popup-content .title {
  font-size: 18px;
  font-weight: 800;
  color: #111;
  margin: 0 0 8px 0;
}

.popup-content .message {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.popup-content .message strong {
  color: #333;
}

.popup-buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.popup-buttons .confirm {
  width: 100%;
  padding: 14px;
  background: #FEE500;
  color: #3C1E1E;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.popup-buttons .confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(254, 229, 0, 0.4);
}

.popup-buttons .confirm:active {
  transform: translateY(0);
}

.popup-buttons .confirm svg {
  flex-shrink: 0;
}

.popup-buttons .cancel {
  width: 100%;
  padding: 12px;
  background: transparent;
  color: #999;
  border: none;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.popup-buttons .cancel:hover {
  background: #f5f5f5;
}

/* 트랜지션 */
.modal-enter-active {
  animation: fadeIn 0.3s ease-out;
}
.modal-enter-active .kakao-invite-popup {
  animation: scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.modal-leave-active {
  animation: fadeOut 0.2s ease-in forwards;
}
.modal-leave-active .kakao-invite-popup {
  animation: scaleOut 0.2s ease-in forwards;
}

@keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
@keyframes fadeOut { from { opacity: 1 } to { opacity: 0 } }
@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.9) translateY(20px) }
  to { opacity: 1; transform: scale(1) translateY(0) }
}
@keyframes scaleOut {
  from { opacity: 1; transform: scale(1) translateY(0) }
  to { opacity: 0; transform: scale(0.95) translateY(10px) }
}
</style>
